/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { dxTrialLeadControllerCapture } from "./dxTrialLeadControllerCapture";
import { dxTrialsControllerSignup } from "./dxTrialsControllerSignup";

export function dxTrialsService() {
  return { dxTrialsControllerSignup, dxTrialLeadControllerCapture }
}